import { getFrontierApiUrl } from '../utils/url';
import { clientLogger } from './endpoints';
import type { LogClientMessage } from './types/logger';

const url = getFrontierApiUrl(clientLogger);

export const logClientMessage = async ({
  value,
  type,
  meta,
}: LogClientMessage) => {
  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      value,
      type,
      meta,
    }),
  });
};
